import { useEffect } from 'react';

import history from 'src/history';
import { getElectronAPI } from 'src/hooks/useElectron';

/**
 * Builds the route for a notification click.
 * All notifications navigate to /notifications?channelId={notificationId}
 */
const getRouteForNotification = (
  metadata?: Record<string, unknown>,
): string => {
  const notificationId = metadata?.notificationId as string | undefined;

  if (notificationId) {
    return `/notifications?channelId=${encodeURIComponent(notificationId)}`;
  }

  // Fallback to notifications inbox
  return '/notifications';
};

/**
 * Hook to handle navigation when a native notification is clicked.
 * Should be initialized once at the app level.
 */
export const useNotificationNavigation = () => {
  useEffect(() => {
    const electronAPI = getElectronAPI();
    if (!electronAPI) return;

    const handleNotificationClick = (
      _notificationId: string,
      metadata?: Record<string, unknown>,
    ) => {
      const route = getRouteForNotification(metadata);
      history.push(route);
    };

    const cleanup = electronAPI.onNotificationClicked(handleNotificationClick);

    return cleanup;
  }, []);
};
